<template>
  <div id="cards">
    <module-title title="今日类别销售 TOP15" />
    <!-- <div style="width: 100%;flex: 1;"> -->
    <el-carousel style="width: 100%;height: 100%;" direction="vertical" :autoplay="true" indicator-position="none">
      <el-carousel-item>
        <div id="topChart" style="width: 26vw;height: 28vh;"></div>
      </el-carousel-item>
    </el-carousel>

    <!-- </div> -->

    <!-- <div id="topChart" style="width: 100%; height: 80%;"></div> -->

  </div>
</template>

<script>
import moduleTitle from '@/components/Common/ModuleTitle.vue';

export default {
  name: 'CardsItem',
  components: {
    moduleTitle
  },
  data() {
    return {
      chart: null, // 用于存储 ECharts 实例

      options: {

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '1%',
          // right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: '#FFFFFF' // 设置 X 轴文字颜色为白色
          },
          axisLine: {
            show: true, //  X 轴轴线
          },
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '2011',
            type: 'bar',
            data: [
            ]
          }
        ]
      }
    }
  },
  props: {
    cardData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getRandomColor(index) {
      // const letters = '0123456789ABCDEF';
      let color = '#';
      // for (let i = 0; i < 6; i++) {
      //   color += letters[Math.floor(Math.random() * 16)];
      // }

      let colorArr = ['F22E2E','FFA837','14D85D','0088F0',];
      if (index>=colorArr.length) {
        index = index%4;
      }
      color = color +colorArr[index];
      return color;
    }
  },
  watch: {
    cardData: {
      handler(newVal, oldVal) {
        console.log('cardData',newVal, oldVal);
        if (newVal.length > 0&&newVal!==oldVal) {
          // 数组倒置
          newVal.reverse();
          this.options.yAxis.data = newVal.map(item => ({value:item.CategoryName,textStyle: { color: '#FFF', width: 40, overflow: 'break' }}));
          this.options.series[0].data = newVal.map((item,index) => ({value:item.SaleAmount,itemStyle: { color: this.getRandomColor(index) }}));
          this.chart.setOption(this.options);
        }
      },
      deep: true
    }
  },
  mounted() {
    // 初始化 ECharts 实例
    this.chart = this.$echarts.init(document.getElementById('topChart')); // 如果你选择了全局引入

    // 使用配置项和数据显示图表
    this.chart.setOption(this.options);
  }
}
</script>

<style lang="less" scoped>
#cards {
  height: 100%;
  width: 100%;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;
  // margin-bottom: 20px;
  display: flex;
  flex-direction: column;

}

</style>
<style lang="less">
.el-carousel__container {
    height: 100% !important;
  }
</style>
